module.exports = __webpack_public_path__ + "img/dsgvo.3752c1ee.png";